export default "__VITE_ASSET__Brcp7YOa__"